import { type StatusType, Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'

export const useStatusTranslator = (): ((status: StatusType) => string) => {
    const translator = useTranslator()
    return (status) => translator.formatTranslation(Translation.STATUS_LABEL, { status })
}
